export const LC_PHOTOS: PLTab = { value: 'photos', text: 'photos' };
export const LC_VIDEO: PLTab = { value: 'video', text: 'video' };
export const LC_FLOOR_PLANS: PLTab = { value: 'floorPlans', text: 'floor plans' };
export const LC_MATTERPORT: PLTab = { value: 'matterport', text: 'matterport' };
